import { Dispatch, Store, bindActionCreators } from "redux";
import { connect } from "react-redux";
import {objectOverride} from 'diy/redux/helper';
import {
    AdvancedView,
    StateProps as AdvancedViewStateProps,
    DispatchProps as AdvancedViewDispatchProps
} from "./components/AdvancedView";
import {AppState} from 'diy/redux/app/state';
import {ModuleSectionData} from './data/payload';
import {updatePayload} from './index';
import {serializeStyleSettings} from './data/serialization';
import {Preset, RoundnessStyle, StyleSettings, ExtrasStyle} from './data/styles';
import {SectionKpiEventsTypes, emitKpiEvent} from "./tracking";

import Modul from '../Modul';

function changeStylePreset(preset: Preset) {
    emitKpiEvent(SectionKpiEventsTypes.StyleChanged, preset.id.toString());
    return changeStyleOptions({preset} as StyleSettings);
}

function changeStyleRoundness(roundness: RoundnessStyle) {
    emitKpiEvent(SectionKpiEventsTypes.StyleChanged, roundness.id.toString());
    return changeStyleOptions({roundness} as StyleSettings);
}

function changeStyleExtras(extras: ExtrasStyle) {
    emitKpiEvent(SectionKpiEventsTypes.StyleChanged, extras.id.toString());
    return changeStyleOptions({extras} as StyleSettings);
}

/**
 * Update styles with partial object
 */
function changeStyleOptions(style: StyleSettings) {
    return (dispatch: Dispatch, getState: () => AppState) => {
        let newStyle = serializeStyleSettings(
            objectOverride(getState().moduleSection.style, style)
        );
        return dispatch(updatePayload({style: newStyle} as ModuleSectionData));
    };
}

function previewStylePreset(preset: Preset) {
    return (dispatch: Dispatch, getState: () => AppState) => {
        let state = getState().moduleSection;
        previewStyleItem<Preset>(
            state.moduleId,
            preset,
            state.availableStyles.presets,
            item => "section-style-preset-" + item.id
        );
    };
}

function previewStyleRoundness(roundness: RoundnessStyle) {
    return (dispatch: Dispatch, getState: () => AppState) => {
        let state = getState().moduleSection;
        previewStyleItem<RoundnessStyle>(
            state.moduleId,
            roundness,
            state.availableStyles.roundness,
            item => "section-style-roundness-" + item.id
        );
    };
}

function previewStyleExtras(extras: ExtrasStyle) {
    return (dispatch: Dispatch, getState: () => AppState) => {
        let state = getState().moduleSection;
        previewStyleItem<ExtrasStyle>(
            state.moduleId,
            extras,
            state.availableStyles.extras,
            item => "section-style-extras-" + item.id
        );
    };
}

function previewStyleItem<T>(moduleId: number, item: T, allItems: T[], cssClassSelector: (item: T) => string) {
    let allCssClasses = allItems.map(p => cssClassSelector(p));
    let moduleEl = Modul.getInstance(moduleId).getModuleElement();
    let classList = moduleEl.get(0).classList;
    // IE11 doesn't support multiple parameters on classList.remove
    allCssClasses.forEach(c => classList.remove(c));
    classList.add(cssClassSelector(item));
}

function mapStateToProps(state: AppState): AdvancedViewStateProps {
    return {
        availableStyles: state.moduleSection.availableStyles,
        style: state.moduleSection.style
    };
}

function mapDispatchToProps(dispatch: Dispatch): AdvancedViewDispatchProps {
    return bindActionCreators({
        onPresetSelect: changeStylePreset,
        onPresetPreview: previewStylePreset,
        onRoundnessSelect: changeStyleRoundness,
        onRoundnessPreview: previewStyleRoundness,
        onExtrasSelect: changeStyleExtras,
        onExtrasPreview: previewStyleExtras
    }, dispatch);
}

export function getAdvancedViewComponent(store: Store) {
    const ConnectedAdvancedView = connect(mapStateToProps, mapDispatchToProps)(AdvancedView);

    return ConnectedAdvancedView;
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/advancedTab.ts
 **/